import { createRoot } from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CssBaseline } from '@mui/material';
import React from 'react';

import { App } from './app';
import * as AuthService from './services/authentication';

import './api/config';

AuthService.initialize();

const root = document.getElementById('app');
if (!root) throw new Error('No root element found');

createRoot(root).render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
);
